import React, { useState } from 'react'
import { cn } from '@utils/safeTs'
import styles from './Tabs.module.sass'

export type TabProps = {
  id: string
  label: string
  component: React.ReactNode
  count?: number
}

export interface TabsProps {
  tabs: TabProps[]
  size?: 'md' | 'sm' | 'xs'
  ariaLabel?: string
  activeId: string
  onTabSelect?: (value: string) => void
  className?: string
  listClassName?: string
  disabled?: boolean
}

const Tabs = (props: TabsProps) => {

  const {
    tabs = [],
    size = 'md',
    ariaLabel,
    activeId,
    onTabSelect,
    className,
    listClassName,
    disabled = false,
  } = props

  return (
    <div className={cn(styles.root, styles[`root--${size}`], className)}>
      <div className={cn(styles.list, listClassName)} role="tablist" aria-label={ariaLabel}>
        {tabs.map((tab) => (
          <button
            key={tab.id}
            id={`${tab.id}_tab`}
            type="button"
            role="tab"
            aria-selected={tab.id === activeId}
            aria-controls={`${tab.id}_tabpanel`}
            disabled={disabled}
            className={cn(styles.tab, tab.id === activeId ? styles['tab--active'] : undefined)}
            onClick={() => onTabSelect(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div className={styles.body}>
        {tabs.map((tab) => (
          <div key={tab.id} className={cn(styles.tabPanel, tab.id === activeId ? styles['tabPanel--active'] : undefined)} id={`${tab.id}_tabpanel`} role="tabpanel" aria-labelledby={`${tab.id}_tab`}>
            {tab.component}
          </div>
        ))}
      </div>
    </div>
  )
}

export default Tabs
